import gql from 'graphql-tag';

export const FUND_MANAGER = gql`
    query InvestmentTeamFundManager($ticker: String!) {
        mutualFund(ticker: $ticker) {
            mutualFundManagers {
                managerID
                educationText
                managerName
                title
                managedFundSinceDate
                joinedFirmDate
                headShots2 {
                    path
                    width
                    height
                }
            }
        }
    }
`;

// @todo perhaps use a fragment here...
export const ETF_FUND_MANAGER = gql`
    query ETFInvestmentTeamFundManager($ticker: String!) {
        exchangeTradedFund(ticker: $ticker) {
            mutualFundManagers {
                managerID
                educationText
                managerName
                title
                managedFundSinceDate
                joinedFirmDate
                headShots2 {
                    path
                    width
                    height
                }
            }
        }
    }
`;
